import packageJSON from './../../package.json';

export const environment = {
    production: true,
    url: '{API_BASE_URL}',
    ssoClientId: '{AUTH0_SSO_CLIENT_ID}',
    ssoUrl: '{AUTH0_SSO_URL}',
    ssoAudience: '{AUTH0_SSO_AUDIENCE}',
    sentryKey: '{SENTRY_KEY}',
    environment: '{ENVIRONMENT}',
    cortexUrl: '{CORTEX_URL}',
    oneviewUrl: '{ONEVIEW_URL}',
    plumeAppId: '{PLUME_APP_ID}',
    synappsAppId: '{SYNAPPS_APP_ID}',
    oneviewAppId: '{ONEVIEW_APP_ID}',
    lockboxId: '{LOCKBOX_APP_ID}',
    cloudFunctionUnprovisioning: '{CLOUD_FUNCTION_URL}',
    jiraUrl: '{JIRA_URL}',
    release: packageJSON.version
};
